import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  // 目的地管理
  {
    path: '/destinations',
    name: 'destinations',
    component: () => import('../views/destinations/DestinationsEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/destination-details',
    name: 'destination-details',
    component: () => import('../views/destinations/DestinationDetails.vue'),
    meta: { requiresAuth: true }
  },
  // 航班优惠管理
  {
    path: '/flight-deals',
    name: 'flight-deals',
    component: () => import('../views/flight-deals/FlightDealsEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/flight-deal-details',
    name: 'flight-deal-details',
    component: () => import('../views/flight-deals/FlightDealDetails.vue'),
    meta: { requiresAuth: true }
  },
  // 内容管理
  {
    path: '/services',
    name: 'services',
    component: () => import('../views/content/ServicesEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/hot-deals',
    name: 'hot-deals',
    component: () => import('../views/content/HotDealsEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/hot-deal-details',
    name: 'hot-deal-details',
    component: () => import('../views/content/HotDealDetails.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/flash-sale',
    name: 'flash-sale',
    component: () => import('../views/content/FlashSaleEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/testimonials',
    name: 'testimonials',
    component: () => import('../views/content/TestimonialsEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/exclusive-deals',
    name: 'exclusive-deals',
    component: () => import('../views/content/ExclusiveDealsEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/exclusive-travel-insurance',
    name: 'exclusive-travel-insurance',
    component: () => import('../views/content/ExclusiveTravelInsuranceEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/hero-background',
    name: 'hero-background',
    component: () => import('../views/content/HeroBackgroundEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/footer',
    name: 'footer',
    component: () => import('../views/content/FooterEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/subscribers',
    name: 'subscribers',
    component: () => import('../views/content/Subscribers.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/faqs',
    name: 'faqs',
    component: () => import('../views/content/Faqs.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: () => import('../views/content/AboutUs.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('../views/content/PrivacyPolicy.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/terms-and-conditions',
    name: 'terms-and-conditions',
    component: () => import('../views/content/TermsAndConditions.vue'),
    meta: { requiresAuth: true }
  },
  // 系统管理
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/system/Users.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/languages',
    name: 'languages',
    component: () => import('../views/system/Languages.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const token = localStorage.getItem('token')
  
  if (requiresAuth && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    next('/destinations')
  } else {
    next()
  }
})

export default router